import { assignRoleToUserService } from "services/company/role/roleService";
import {
  getRoles as getRolesService,
  // createRole as createRoleService,
} from "services/company/role/roleService";
import {
  getRolesStart,
  getRolesSuccess,
  getRolesFailure,
  assignRoleStart,
  assignRoleSuccess,
  assignRoleFailure,
} from "./roleSlice";

import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all roles
export const fetchRoles = () => async (dispatch) => {
  try {
    dispatch(getRolesStart());
    const response = await getRolesService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getRolesSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch roles";
      dispatch(getRolesFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch roles error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch roles";
    dispatch(getRolesFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};


export const assignRoleToUser = (roleId) => async (dispatch) => {
  try {
    dispatch(assignRoleStart());

    // Construct payload as shown in your Postman collection snapshot: { "role_id": 3 }
    const payload = { role_id: roleId };
    const response = await assignRoleToUserService(payload);

    console.log("response --------------->", response);

    if (response?.meta?.status === true || response?.meta?.code === 200) {
      console.log("trying dispatch");
      dispatch(
        assignRoleSuccess(response.data.role_id)
        // assignRoleSuccess("1", "2")
      );

      console.log("roleId type", typeof roleId);


      // Call the GET API again to refresh the list with updated statuses
      // dispatch(fetchRoles());

      showSuccessToast(response?.meta?.message || "Role assigned successfully!");
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to assign role";
      dispatch(assignRoleFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Assign role error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to assign role";
    dispatch(assignRoleFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

